module.exports = __webpack_public_path__ + "img/kids.385ffa6e.svg";